"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOperatorLabel;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var operatorLabels = {
  isempty: 'Is Empty',
  contains: 'Contains',
  notcontains: 'Does Not Contain',
  beginswith: 'Begins With',
  equals: 'Is',
  notequals: 'Is Not',
  lessthan: 'Less Than',
  lessthanorequal: 'Lesser or Equal',
  greaterthan: 'Greater Than',
  greaterthanorequal: 'Greater or Equal',
  dateequals: 'Is',
  datebefore: 'Before',
  dateafter: 'After',
  datewithin: 'Within'
};
function getOperatorLabel(operatorId) {
  return operatorLabels[operatorId];
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(operatorLabels, "operatorLabels", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/get-operator-labels.js");
  reactHotLoader.register(getOperatorLabel, "getOperatorLabel", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/get-operator-labels.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJvcGVyYXRvckxhYmVscyIsImlzZW1wdHkiLCJjb250YWlucyIsIm5vdGNvbnRhaW5zIiwiYmVnaW5zd2l0aCIsImVxdWFscyIsIm5vdGVxdWFscyIsImxlc3N0aGFuIiwibGVzc3RoYW5vcmVxdWFsIiwiZ3JlYXRlcnRoYW4iLCJncmVhdGVydGhhbm9yZXF1YWwiLCJkYXRlZXF1YWxzIiwiZGF0ZWJlZm9yZSIsImRhdGVhZnRlciIsImRhdGV3aXRoaW4iLCJnZXRPcGVyYXRvckxhYmVsIiwib3BlcmF0b3JJZCJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tb24vZ2V0LW9wZXJhdG9yLWxhYmVscy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBvcGVyYXRvckxhYmVscyA9IHtcblx0aXNlbXB0eTogJ0lzIEVtcHR5Jyxcblx0Y29udGFpbnM6ICdDb250YWlucycsXG5cdG5vdGNvbnRhaW5zOiAnRG9lcyBOb3QgQ29udGFpbicsXG5cdGJlZ2luc3dpdGg6ICdCZWdpbnMgV2l0aCcsXG5cdGVxdWFsczogJ0lzJyxcblx0bm90ZXF1YWxzOiAnSXMgTm90Jyxcblx0bGVzc3RoYW46ICdMZXNzIFRoYW4nLFxuXHRsZXNzdGhhbm9yZXF1YWw6ICdMZXNzZXIgb3IgRXF1YWwnLFxuXHRncmVhdGVydGhhbjogJ0dyZWF0ZXIgVGhhbicsXG5cdGdyZWF0ZXJ0aGFub3JlcXVhbDogJ0dyZWF0ZXIgb3IgRXF1YWwnLFxuXHRkYXRlZXF1YWxzOiAnSXMnLFxuXHRkYXRlYmVmb3JlOiAnQmVmb3JlJyxcblx0ZGF0ZWFmdGVyOiAnQWZ0ZXInLFxuXHRkYXRld2l0aGluOiAnV2l0aGluJyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGdldE9wZXJhdG9yTGFiZWwob3BlcmF0b3JJZCkge1xuXHRyZXR1cm4gb3BlcmF0b3JMYWJlbHNbb3BlcmF0b3JJZF07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFNQSxjQUFjLEdBQUc7RUFDdEJDLE9BQU8sRUFBRSxVQUFVO0VBQ25CQyxRQUFRLEVBQUUsVUFBVTtFQUNwQkMsV0FBVyxFQUFFLGtCQUFrQjtFQUMvQkMsVUFBVSxFQUFFLGFBQWE7RUFDekJDLE1BQU0sRUFBRSxJQUFJO0VBQ1pDLFNBQVMsRUFBRSxRQUFRO0VBQ25CQyxRQUFRLEVBQUUsV0FBVztFQUNyQkMsZUFBZSxFQUFFLGlCQUFpQjtFQUNsQ0MsV0FBVyxFQUFFLGNBQWM7RUFDM0JDLGtCQUFrQixFQUFFLGtCQUFrQjtFQUN0Q0MsVUFBVSxFQUFFLElBQUk7RUFDaEJDLFVBQVUsRUFBRSxRQUFRO0VBQ3BCQyxTQUFTLEVBQUUsT0FBTztFQUNsQkMsVUFBVSxFQUFFO0FBQ2IsQ0FBQztBQUVjLFNBQVNDLGdCQUFnQixDQUFDQyxVQUFVLEVBQUU7RUFDcEQsT0FBT2hCLGNBQWMsQ0FBQ2dCLFVBQVUsQ0FBQztBQUNsQztBQUFDO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBLHdCQW5CS2hCLGNBQWM7RUFBQSx3QkFpQkllLGdCQUFnQjtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9